import React from 'react';

const InboxImg: React.FC = (props) => (
  <svg viewBox="0 0 535.538 474.071" {...props}>
    <defs>
      <linearGradient
        id="prefix__linear-gradient"
        x1={-136.716}
        y1={85.338}
        x2={4.399}
        y2={85.338}
        gradientTransform="matrix(.818 -.355 0 1 88.514 172.44)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.121} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.4} stopColor="#bbd6ff" stopOpacity={0.332} />
        <stop offset={0.816} stopColor="#5a9cff" stopOpacity={0.809} />
        <stop offset={1} stopColor="#3384ff" />
      </linearGradient>
      <linearGradient
        id="prefix__linear-gradient-2"
        x1={292.375}
        y1={66.313}
        x2={311.681}
        y2={66.313}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.657} stopColor="#0065ff" />
        <stop offset={0.756} stopColor="#0060f0" />
        <stop offset={0.937} stopColor="#0052cc" />
      </linearGradient>
      <linearGradient
        id="prefix__linear-gradient-4"
        x1={-158.115}
        y1={294.262}
        x2={51.105}
        y2={294.262}
        xlinkHref="#prefix__linear-gradient"
      />
      <linearGradient
        id="prefix__linear-gradient-5"
        x1={-158.115}
        y1={309.083}
        x2={51.105}
        y2={309.083}
        xlinkHref="#prefix__linear-gradient"
      />
      <linearGradient
        id="prefix__linear-gradient-6"
        x1={-158.115}
        y1={301.206}
        x2={51.105}
        y2={301.206}
        xlinkHref="#prefix__linear-gradient"
      />
      <linearGradient
        id="prefix__linear-gradient-7"
        x1={376.152}
        y1={474.071}
        x2={376.152}
        y2={246.333}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#0065ff" stopOpacity={0} />
        <stop offset={0.661} stopColor="#0065ff" stopOpacity={0.673} />
        <stop offset={1} stopColor="#0065ff" />
      </linearGradient>
      <linearGradient
        id="prefix__linear-gradient-8"
        x1={381.752}
        y1={248.741}
        x2={319.155}
        y2={35.582}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#6bd5e5" />
        <stop offset={0.203} stopColor="#67d4e4" />
        <stop offset={0.394} stopColor="#5cd0e2" />
        <stop offset={0.579} stopColor="#49c9de" />
        <stop offset={0.759} stopColor="#2fbfd8" />
        <stop offset={0.857} stopColor="#1db9d4" />
      </linearGradient>
      <linearGradient
        id="prefix__linear-gradient-9"
        x1={297.786}
        y1={271.526}
        x2={297.786}
        y2={100.805}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#00a3bf" />
        <stop offset={0.818} stopColor="#00c7e5" />
      </linearGradient>
      <linearGradient
        id="prefix__linear-gradient-10"
        x1={242.54}
        y1={73.753}
        x2={473.423}
        y2={304.635}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.119} stopColor="#7a869a" stopOpacity={0} />
        <stop offset={1} stopColor="#7a869a" />
      </linearGradient>
      <linearGradient
        id="prefix__linear-gradient-11"
        x1={22.116}
        y1={169.947}
        x2={173.833}
        y2={18.23}
        gradientTransform="matrix(.818 -.355 0 1 88.514 172.44)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#0065ff" />
        <stop offset={0.818} stopColor="#3384ff" />
      </linearGradient>
      <linearGradient
        id="prefix__linear-gradient-12"
        x1={287.083}
        y1={124.032}
        x2={287.083}
        y2={77.423}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.547} stopColor="#0052cc" />
        <stop offset={0.902} stopColor="#2684ff" />
        <stop offset={0.933} stopColor="#2481fc" />
        <stop offset={0.958} stopColor="#1c77f2" />
        <stop offset={0.98} stopColor="#1067e1" />
        <stop offset={1} stopColor="#0052cc" />
      </linearGradient>
      <linearGradient
        id="prefix__linear-gradient-13"
        x1={298.353}
        y1={125.998}
        x2={298.353}
        y2={77.25}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.481} stopColor="#0052cc" />
        <stop offset={0.926} stopColor="#2684ff" />
        <stop offset={0.945} stopColor="#227ffa" />
        <stop offset={0.969} stopColor="#1771eb" />
        <stop offset={0.994} stopColor="#0559d3" />
        <stop offset={1} stopColor="#0052cc" />
      </linearGradient>
      <linearGradient
        id="prefix__linear-gradient-14"
        x1={274.475}
        y1={59.599}
        x2={295.653}
        y2={59.599}
        gradientTransform="rotate(37.942 286.848 58.43)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.628} stopColor="#0065ff" />
        <stop offset={0.765} stopColor="#005ae1" />
        <stop offset={0.852} stopColor="#0052cc" />
      </linearGradient>
      <linearGradient
        id="prefix__New_Gradient_Swatch_13"
        x1={-40.95}
        y1={-1059.962}
        x2={-36.771}
        y2={-1064.142}
        gradientTransform="matrix(1 0 0 -1.522 312.893 -1573.203)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#00c7e5" />
        <stop offset={1} stopColor="#b3f5ff" />
      </linearGradient>
      <linearGradient
        id="prefix__New_Gradient_Swatch_13-2"
        x1={-40.594}
        y1={-1065.291}
        x2={-37.128}
        y2={-1068.757}
        gradientTransform="matrix(1 0 0 -1.522 320.464 -1580.944)"
        xlinkHref="#prefix__New_Gradient_Swatch_13"
      />
      <linearGradient
        id="prefix__New_Gradient_Swatch_13-3"
        x1={-40.185}
        y1={-1070.019}
        x2={-37.537}
        y2={-1072.667}
        gradientTransform="matrix(1 0 0 -1.522 326.899 -1587.525)"
        xlinkHref="#prefix__New_Gradient_Swatch_13"
      />
      <linearGradient
        id="prefix__linear-gradient-16"
        x1={295.563}
        y1={77.114}
        x2={319.051}
        y2={62.939}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.279} stopColor="#2684ff" />
        <stop offset={0.56} stopColor="#086cff" />
        <stop offset={0.628} stopColor="#0065ff" />
        <stop offset={0.765} stopColor="#005ae1" />
        <stop offset={0.852} stopColor="#0052cc" />
      </linearGradient>
      <linearGradient
        id="prefix__New_Gradient_Swatch_11"
        x1={310.986}
        y1={194.755}
        x2={363.199}
        y2={194.755}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#00a3bf" />
        <stop offset={1} stopColor="#00c7e5" />
      </linearGradient>
      <linearGradient
        id="prefix__New_Gradient_Swatch_2"
        x1={330.492}
        y1={219.33}
        x2={330.492}
        y2={191.873}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#ff5630" />
        <stop offset={1} stopColor="#ff8f73" />
      </linearGradient>
      <linearGradient
        id="prefix__New_Gradient_Swatch_2-2"
        x1={343.475}
        y1={219.534}
        x2={343.475}
        y2={191.768}
        xlinkHref="#prefix__New_Gradient_Swatch_2"
      />
      <linearGradient
        id="prefix__linear-gradient-17"
        x1={116.917}
        y1={-2418.323}
        x2={110.364}
        y2={-2429.673}
        gradientTransform="matrix(.912 -.365 -.022 -1.088 -45.115 -2378.143)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0.4} />
        <stop offset={0.92} stopColor="#fff" />
      </linearGradient>
      <radialGradient
        id="prefix__radial-gradient"
        cx={333.607}
        cy={227.537}
        r={18.393}
        gradientTransform="rotate(81.59 311.98 208.873) scale(1 .836)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.164} stopColor="#00b8d9" />
        <stop offset={0.363} stopColor="#00b5d6" />
        <stop offset={0.525} stopColor="#00adcc" />
        <stop offset={0.642} stopColor="#00a3bf" />
      </radialGradient>
      <radialGradient
        id="prefix__radial-gradient-2"
        cx={336.354}
        cy={227.33}
        r={22.804}
        gradientTransform="matrix(.032 .999 -.663 .021 476.454 -113.664)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#00c7e5" />
        <stop offset={0.398} stopColor="#00c4e2" />
        <stop offset={0.741} stopColor="#00b9da" />
        <stop offset={0.765} stopColor="#00b8d9" />
      </radialGradient>
      <clipPath id="prefix__clip-path">
        <path
          id="prefix___Clipping_Path_"
          data-name="&lt;Clipping Path&gt;"
          className="prefix__cls-1"
          d="M103.743 321.455L0 366.224V225.881l103.743-33.508v129.082z"
        />
      </clipPath>
      <clipPath id="prefix__clip-path-2">
        <path
          id="prefix___Clipping_Path_2"
          data-name="&lt;Clipping Path&gt;"
          className="prefix__cls-2"
          d="M309.714 54.989c2.04 1.878 2.36 5.189 1.57 8.535-.382 1.62-.347 2.447-.557 3.721a28.089 28.089 0 00.471 10.876c-.47.12-1.175.287-2.04.446a42.432 42.432 0 01-5.06.528c-2.593.185-3.9.282-4.588.244a21.493 21.493 0 01-3.845-.563c.732-5.805-.342-9.334-1.546-11.525-.741-1.349-2.216-3.436-1.6-5.588.234-.812.749-1.575 1.206-3.334a16.269 16.269 0 00.423-2.3l1.942-1.586a4.353 4.353 0 007.127-1.082 8.549 8.549 0 011.19-.086c.445.003 3.478.031 5.307 1.714z"
        />
      </clipPath>
      <style>
        {
          '.prefix__cls-1{fill:url(#prefix__linear-gradient)}.prefix__cls-2{fill:url(#prefix__linear-gradient-2)}.prefix__cls-33,.prefix__cls-9{fill:#00c7e5}.prefix__cls-9{opacity:.3}.prefix__cls-22,.prefix__cls-43,.prefix__cls-45{fill:none}.prefix__cls-43{stroke-miterlimit:10}.prefix__cls-12{fill:#9ce3ee}.prefix__cls-16{fill:#1db9d4}.prefix__cls-18{fill:#3384ff}.prefix__cls-21{fill:#fff}.prefix__cls-22{stroke:#ff5230;stroke-width:2.321px}.prefix__cls-23{fill:#e0ada6}.prefix__cls-24{fill:#253858}.prefix__cls-36{fill:#344563}.prefix__cls-37{fill:#b5917c}.prefix__cls-43{stroke:#ff5630;stroke-width:2px}'
        }
      </style>
    </defs>
    <title>{'Incoming'}</title>
    <g
      style={{
        isolation: 'isolate'
      }}
    >
      <g id="prefix__Layer_2" data-name="Layer 2">
        <g id="prefix__Layer_1-2" data-name="Layer 1">
          <g
            style={{
              mixBlendMode: 'multiply'
            }}
            opacity={0.19}
          >
            <path
              id="prefix___Clipping_Path_3"
              data-name="&lt;Clipping Path&gt;"
              className="prefix__cls-1"
              d="M103.743 321.455L0 366.224V225.881l103.743-33.508v129.082z"
            />
            <g clipPath="url(#prefix__clip-path)">
              <path
                fill="url(#prefix__linear-gradient-4)"
                d="M5.398 302.743l39.117-16.962"
              />
              <path
                fill="url(#prefix__linear-gradient-5)"
                d="M5.398 317.564l39.117-16.962"
              />
              <path
                fill="url(#prefix__linear-gradient-6)"
                d="M5.398 309.687l39.117-16.962"
              />
            </g>
          </g>
          <path
            className="prefix__cls-9"
            d="M151.657 108.409c8.351.127 7.9 4.325 14.51 3.148 7.577-1.348 8.567-11.762 19.038-11.762 17.342 0 17.333 18.018 17.333 18.018s2.945 8.756 9.98 9.083a1.288 1.288 0 01.287.025c0 .219-68.3.082-91.323.036-6.854-.014-20.048-.044-26.595-.062 10.939-4.014 16.046-4.736 18.487-4.09 5.563 1.472 2.827-6.3 12.407-8.45 7.553-1.694 8.888 1.251 12.952 1.251 7.198.001 2.781-6.215 12.924-7.197zM474.391 8.614c8.351.127 7.9 4.325 14.51 3.148C496.477 10.413 497.468 0 507.938 0c17.342 0 17.333 18.018 17.333 18.018s2.945 8.756 9.98 9.083a1.288 1.288 0 01.287.025c0 .219-68.3.082-91.323.036-6.854-.014-20.048-.044-26.595-.062 10.939-4.014 16.046-4.736 18.487-4.09 5.563 1.472 2.827-6.3 12.407-8.45 7.553-1.694 8.888 1.251 12.952 1.251 7.199.001 2.781-6.211 12.925-7.197z"
          />
          <path
            strokeWidth={19.44}
            stroke="url(#prefix__linear-gradient-7)"
            strokeMiterlimit={10}
            fill="none"
            d="M376.152 246.333v227.738"
          />
          <path
            className="prefix__cls-9"
            d="M508.348 292.622c-1.236-12.277-4.055-16.728-14.045-16.8s-10.56 3.127-13.713 5.658-5.688 1.941-9.706 1.224-8.655-1.181-12.673 1.434-4.637 3.8-10.077 3.333c-4.73-.4-5.955-.353-8.172.27a16.478 16.478 0 00-3.05 1.34c-5.09 2.58-6.065 4.342-9.4 5.643a17.024 17.024 0 01-6.146 1.1l86.984.4z"
          />
          <path
            id="prefix___Path_"
            data-name="&lt;Path&gt;"
            d="M427.644 49.459a58.919 58.919 0 00-18.08 2.828c-.288.088-128.712 40.5-129 40.6a58.992 58.992 0 00-41.748 56.411v122.321h117.939l129.858-44.872V104.422c0-32.567-26.402-54.963-58.969-54.963z"
            fill="url(#prefix__linear-gradient-8)"
          />
          <path
            className="prefix__cls-12"
            d="M486.613 211.789l-.006-.017-129.378 43.646.777 2.303 128.607-43.386v-2.546zM486.607 203.459l-129.378 43.645.777 2.303 128.607-43.385v-2.546l-.006-.017zM486.607 118.245l-129.378 43.647.777 2.302 128.607-43.386v-2.546l-.006-.017zM486.607 109.932l-129.378 43.646.777 2.303 128.607-43.386v-2.547l-.006-.016z"
          />
          <path
            d="M373.347 256.707v-126.15a58.977 58.977 0 00-37.716-55.005l-5.756 1.812a58.988 58.988 0 0138.925 55.468v122.73z"
            style={{
              mixBlendMode: 'multiply'
            }}
            fill="#ebecf0"
            opacity={0.62}
          />
          <path
            id="prefix___Path_2"
            data-name="&lt;Path&gt;"
            d="M297.786 90.325a58.969 58.969 0 00-58.969 58.969v122.325h117.938V149.294a58.969 58.969 0 00-58.969-58.969z"
            fill="#0065ff"
          />
          <path
            d="M356.755 224.881l-16.42 6.494c-22.883-13.854-38.335-39.285-38.371-65.094a75.843 75.843 0 00-37.723-65.476 58.891 58.891 0 00-25.423 48.446v122.275l93.075-36.811z"
            fill="url(#prefix__linear-gradient-9)"
          />
          <path
            className="prefix__cls-16"
            d="M297.786 90.325c-1.346 0-2.676.061-4 .15h8a60.186 60.186 0 00-4-.15z"
          />
          <path
            className="prefix__cls-16"
            d="M301.964 166.281c.038 25.809 15.488 51.24 38.371 65.094l16.42-6.494v-75.587a58.961 58.961 0 00-54.969-58.819h-8a58.628 58.628 0 00-29.546 10.33 75.843 75.843 0 0137.724 65.476z"
          />
          <path
            d="M301.964 166.281c.038 25.809 15.488 51.24 38.371 65.094l16.42-6.494v-75.587a58.961 58.961 0 00-54.969-58.819h-8a58.628 58.628 0 00-29.546 10.33 75.843 75.843 0 0137.724 65.476z"
            style={{
              mixBlendMode: 'multiply'
            }}
            fill="url(#prefix__linear-gradient-10)"
          />
          <path
            id="prefix___Clipping_Path_4"
            data-name="&lt;Clipping Path&gt;"
            className="prefix__cls-18"
            d="M297.917 433.7c-32.568 0-58.969-23.636-58.969-52.792V271.393h117.937v109.512c0 29.157-26.401 52.795-58.968 52.795z"
          />
          <path
            id="prefix___Path_3"
            data-name="&lt;Path&gt;"
            fill="url(#prefix__linear-gradient-11)"
            d="M248.699 258.602L94.887 325.299V194.551l153.812-51.335v115.386z"
          />
          <path
            fill="#ff5230"
            d="M378.124 72.088l-4.777 1.853v182.757l4.777-1.853V98.244l29.21-10.698V62.231l-29.21 9.857z"
          />
          <path
            className="prefix__cls-21"
            d="M241.831 179.947l-21.375 9.269v-27.067l21.375-8.336v26.134z"
          />
          <path
            className="prefix__cls-22"
            d="M184.7 192.47c3.309-1.435 3.309 1.722 6.617.288s3.31-4.592 6.619-6.027 3.309 1.722 6.617.288 3.311-4.593 6.622-6.028a3.993 3.993 0 011.624-.384M184.7 204.221c3.309-1.435 3.309 1.722 6.617.288s3.31-4.592 6.619-6.027 3.309 1.722 6.617.288 3.311-4.593 6.622-6.028a3.677 3.677 0 011.9-.367M184.7 198.346c3.309-1.435 3.309 1.722 6.617.288s3.31-4.592 6.619-6.027 3.309 1.722 6.617.288 3.311-4.593 6.622-6.028a5.342 5.342 0 01.731-.26"
          />
          <path
            id="prefix___Path_4"
            data-name="&lt;Path&gt;"
            className="prefix__cls-22"
            d="M233.332 177.632c0 7.232-4.8 15.175-10.711 17.74s-10.711-1.218-10.711-8.451 4.8-15.175 10.711-17.74 10.711 1.219 10.711 8.451z"
          />
          <path
            className="prefix__cls-23"
            d="M294.376 79.076c-12.172 4.071-18.2 6.466-20.009 10.37-.934 2.015-.583 2.9-.54 9.438a145.2 145.2 0 01-.868 16.945 8.264 8.264 0 01-.512 1.669c-1.59 3.715-5.3 4.673-5.027 5.717.2.75 2.316 1.016 3.925.662 1.025-.226 2.276-1.3 4.777-3.452.867-.746 1.486-1.243 1.649-2.123a9.087 9.087 0 00-.216-2.337 9.486 9.486 0 01-.162-1.872c-.244-1.455 4.407-10.288 5.368-16.663a21.635 21.635 0 00.239-3.257 74.506 74.506 0 0015.765-4.81 10.342 10.342 0 002.226-8.013 9.3 9.3 0 00-1.742-3.927c-1.226.394-2.886.988-4.873 1.653z"
          />
          <path
            className="prefix__cls-23"
            d="M284.676 102.975c-.15-2.27-.348-4.542-.351-6.817 0-2.691.171-4.973.361-7.719a3.957 3.957 0 012.007-3.143l16.747-8.046 5 .235a4.429 4.429 0 012.162.986c1.229 1.065 1.552 3.11 1.667 3.892a10.032 10.032 0 01.042 2.741c-.439 2.713-6.071 3.573-14.672 6.366l-3.6 1.242a42.646 42.646 0 01-.166 7.178 43.081 43.081 0 01-3.518 12.958c-1.654 2.708-1.723 4.592-1.445 5.84a3.774 3.774 0 01.246 2.152c-.316 1-1.2 1.254-3.072 2.489-2.366 1.562-2.107 1.92-3.223 2.32-1.95.7-4.671.3-5.036-.775-.508-1.49 4.153-2.421 6.481-6.73 1.224-2.272.939-6.571.37-15.169z"
          />
          <path
            className="prefix__cls-24"
            d="M294.6 45.948c-.676.278.958 3.069-.149 5.954-1.095 2.853-3.733 2.834-4.242 5.507-.274 1.44.13 3.338 1.3 3.907 1.513.735 3.614-1.081 3.87-1.3 3.012-2.6 3.435-7.77 1.712-11.312-.738-1.528-1.982-2.964-2.491-2.756z"
          />
          <path
            className="prefix__cls-23"
            d="M296.717 49.781a7.179 7.179 0 01.278 2.366 7.255 7.255 0 01-.948 3.218 9.468 9.468 0 006.548-.574 9.161 9.161 0 011.247-7.191z"
          />
          <path
            d="M300.99 81.349a9.3 9.3 0 00-1.742-3.927c-1.225.394-2.884.989-4.872 1.653-12.172 4.071-18.2 6.466-20.009 10.37-.934 2.015-.583 2.9-.54 9.438a145.1 145.1 0 01-.791 16.22 7.846 7.846 0 014.366-1.337c.269-2.135 4.453-10.326 5.359-16.338a21.635 21.635 0 00.239-3.255 74.506 74.506 0 0015.765-4.81 10.342 10.342 0 002.225-8.014z"
            fill="url(#prefix__linear-gradient-12)"
          />
          <path
            d="M312.266 82.363c-.115-.782-.438-2.828-1.667-3.892a4.429 4.429 0 00-2.162-.986l-5-.235-16.745 8.05a3.957 3.957 0 00-2.007 3.143c-.19 2.746-.365 5.029-.361 7.719 0 2.275.2 4.547.351 6.817.48 7.25.754 11.437.094 13.936a8.371 8.371 0 013.371-.667c.266 0 .52.018.772.038a10.68 10.68 0 011.438-3.433 43.081 43.081 0 003.518-12.958 42.646 42.646 0 00.166-7.178l3.6-1.242c8.6-2.793 14.233-3.653 14.672-6.366a10.032 10.032 0 00-.04-2.746z"
            fill="url(#prefix__linear-gradient-13)"
          />
          <path
            className="prefix__cls-23"
            d="M294.891 55.53a28.349 28.349 0 01-5.13 3.058 34.548 34.548 0 00-4.955 2.559c-.483.308-.873.576-1.136.761 0-.683-.016-1.722-.095-2.987-.132-2.1-.35-3.4-.763-6.434-.147-1.079-.356-2.66-.594-4.6l-2.557-.357a58.4 58.4 0 00-.907 7.629 33.021 33.021 0 00.21 7.41 28.43 28.43 0 00.655 3.071 1.507 1.507 0 001.548 1.116 30.456 30.456 0 004.025-.522c2.936-.582 8.66-1.718 11.341-5.974.441-.7 1.615-2.565.85-3.762a3.022 3.022 0 00-2.492-.968z"
          />
          <path
            d="M296.532 60.256c.441-.7 1.615-2.565.85-3.762a3.022 3.022 0 00-2.491-.964 28.349 28.349 0 01-5.13 3.058 34.548 34.548 0 00-4.955 2.559c-.483.308-.873.576-1.136.761 0-.683-.016-1.722-.095-2.987-.132-2.1-.35-3.4-.763-6.434-.068-.5-.15-1.114-.241-1.812a7.146 7.146 0 01-3.4.032 58.706 58.706 0 00-.414 4.449 33.021 33.021 0 00.21 7.41 28.43 28.43 0 00.655 3.071 1.507 1.507 0 001.548 1.116 30.456 30.456 0 004.025-.522c2.932-.583 8.656-1.719 11.337-5.975z"
            fill="url(#prefix__linear-gradient-14)"
          />
          <path
            id="prefix___Clipping_Path_5"
            data-name="&lt;Clipping Path&gt;"
            className="prefix__cls-2"
            d="M309.714 54.989c2.04 1.878 2.36 5.189 1.57 8.535-.382 1.62-.347 2.447-.557 3.721a28.089 28.089 0 00.471 10.876c-.47.12-1.175.287-2.04.446a42.432 42.432 0 01-5.06.528c-2.593.185-3.9.282-4.588.244a21.493 21.493 0 01-3.845-.563c.732-5.805-.342-9.334-1.546-11.525-.741-1.349-2.216-3.436-1.6-5.588.234-.812.749-1.575 1.206-3.334a16.269 16.269 0 00.423-2.3l1.942-1.586a4.353 4.353 0 007.127-1.082 8.549 8.549 0 011.19-.086c.445.003 3.478.031 5.307 1.714z"
          />
          <g clipPath="url(#prefix__clip-path-2)">
            <path className="prefix__cls-18" d="M292.038 65.434l.114-3.497" />
          </g>
          <path
            className="prefix__cls-23"
            d="M294.322 39.432a4.769 4.769 0 00-1.3 3.069l-.022.659s.032.373-.871 1.615c-.279.384 1.2.782 1.2.782a5.74 5.74 0 00.12 1.793c.06.255.1.32.217.8a9.069 9.069 0 00.325 1.35c.2.327.768.627 2.47.4a10.764 10.764 0 014.46-.637 2.55 2.55 0 002.923-1.657 6.142 6.142 0 001.085-1.827 6.281 6.281 0 00-.518-5.645 6.913 6.913 0 00-.9-1.112 5.019 5.019 0 00-4.3-1.345l-2.123.319a4.775 4.775 0 00-2.766 1.436z"
          />
          <path
            className="prefix__cls-24"
            d="M292.259 41.751q1.318.089 2.7.219t2.7.3a15.394 15.394 0 00-.161 2.507 25.653 25.653 0 001.034 4.752 7.074 7.074 0 01-.183 4.769c-.8 1.6-1.192 1.914-1.152 3.041a3.906 3.906 0 002.839 3.482c2.047.417 4.018-1.722 4.846-2.621 1.688-1.832 2.029-3.546 3.36-3.68a2.322 2.322 0 011.623.592 8.665 8.665 0 00.721-5.071 8.354 8.354 0 00-.988-2.728A17.917 17.917 0 00307.682 45a12.717 12.717 0 01-1.636-3.761 6.357 6.357 0 00-2.2-3.4 6.505 6.505 0 00-2.4-.837 11.92 11.92 0 00-4.553-.179 5.665 5.665 0 00-4.635 4.925z"
          />
          <path
            className="prefix__cls-23"
            d="M282.515 46.878a3.58 3.58 0 01-.829.9 2.138 2.138 0 01-.906.3c-.713.106-.937.763-1.194.647s.063-.816-.2-1.957c-.149-.656-.325-.716-.331-1.241a3.367 3.367 0 01.36-1.366c.277-.69.469-.769.575-.785a.6.6 0 01.462.189c.112-.526.281-.691.429-.73.276-.074.728.223.728.223.052-.072.38-.523.631-.448.086.026.135.1.292.469.293.681.244.69.335.785.312.324.765.08.995.393a.765.765 0 01.065.595c-.065.373-.266.528-.72 1.1-.334.413-.24.348-.692.926z"
          />
          <path
            className="prefix__cls-23"
            d="M280.112 47.633c-.11-.3.2-.677.857-1.362a4.23 4.23 0 011.506-1.11c.726-.3.8-.039 1.521-.364.6-.267.817-.56 1.313-.529.284.018.629.141.65.312s-.24.3-.452.426a9.5 9.5 0 00-1.456 1.088 2.133 2.133 0 01-.5 1.134 2.231 2.231 0 01-1.091.654c-.882.275-2.165.247-2.348-.249z"
          />
          <path
            d="M272.4 39.873h3.271V47.5a.39.39 0 01-.39.39h-2.492a.39.39 0 01-.39-.39v-7.627z"
            transform="rotate(-91.278 274.03 43.883)"
            fill="url(#prefix__New_Gradient_Swatch_13)"
          />
          <path
            d="M280.384 40.15h2.434v6.729a.4.4 0 01-.4.4h-1.64a.4.4 0 01-.4-.4V40.15h.006z"
            transform="rotate(-91.278 281.6 43.714)"
            fill="url(#prefix__New_Gradient_Swatch_13-2)"
          />
          <path
            transform="rotate(-91.26 288.056 43.493)"
            fill="url(#prefix__New_Gradient_Swatch_13-3)"
            d="M287.277 40.696h1.52v5.748h-1.52z"
          />
          <rect
            className="prefix__cls-33"
            x={289.992}
            y={43.2}
            width={2.421}
            height={0.586}
            rx={0.237}
            ry={0.237}
            transform="rotate(-91.278 291.202 43.494)"
          />
          <rect
            className="prefix__cls-33"
            x={267.587}
            y={43.501}
            width={3.922}
            height={0.949}
            rx={0.385}
            ry={0.385}
            transform="rotate(-91.278 269.547 43.976)"
          />
          <path
            className="prefix__cls-23"
            d="M282.441 43.68a.511.511 0 01-.354-.086c-.264-.172-.25-.509-.359-.513-.132 0-.144.492-.427.586a.459.459 0 01-.4-.1c-.206-.165-.129-.4-.26-.467-.23-.119-.605.532-.906.45-.268-.073-.447-.706-.272-1.2.248-.7 1.13-.907 1.431-.979a3.717 3.717 0 012 .233c.6.166.8.308.914.5a1.365 1.365 0 01.128.823c-.015.2-.034.452-.155.493-.2.066-.42-.509-.7-.467s-.281.655-.64.727z"
          />
          <path
            className="prefix__cls-24"
            d="M277.555 115.964a8.1 8.1 0 01-.121-.83 9.138 9.138 0 01-.036-.633 25.65 25.65 0 00-.911 1.442c-1.244 2.12-1.339 2.969-2.118 3.4-.5.276-1.337.419-2.832-.262-.6.483-1.456 1.2-2.457 2.128-1.6 1.482-1.72 1.778-1.66 2 .19.716 2.212 1.039 3.925.662 1.025-.226 2.276-1.3 4.777-3.452 1.074-.923 1.554-1.4 1.649-2.123a9.413 9.413 0 00-.216-2.332zM288.791 117.2a6.228 6.228 0 00-1.162.927c-1.453 1.478-1.133 2.67-2.387 3.627a3.564 3.564 0 01-2.465.693 3.36 3.36 0 01-1.656-.7c-1.9 1.469-3.619 2.186-3.3 3.121.366 1.074 3.086 1.474 5.036.775.76-.272.883-.525 1.631-1.152a13.559 13.559 0 011.592-1.167c.914-.588 1.36-.72 1.865-1.074a4.044 4.044 0 00.492-.4 3.451 3.451 0 00.834-1.011c.225-.513 0-.872-.256-2.152a16.404 16.404 0 01-.224-1.487z"
          />
          <path
            className="prefix__cls-23"
            d="M308.174 54.517a2.986 2.986 0 012.27 1.081c.757.81 1.031 1.843 1.132 3.558a21.578 21.578 0 01-.393 5.566c-.4 1.93-.964 4.7-1.7 8.559a47.38 47.38 0 01-6.229 15.759l-2.512-.842c.383-1.091.653-1.973.809-2.5 1.577-5.334 1.393-7.84 3.206-11.717.363-.776.7-1.375.878-1.688q-.089-1.532-.148-3.1c-.151-4.062-.128-7.965.029-11.694a3.4 3.4 0 012.658-2.982z"
          />
          <path
            className="prefix__cls-23"
            d="M299.05 89.428a7.251 7.251 0 00-1.69.948 8.338 8.338 0 00.352 3.753.533.533 0 00.276.162.438.438 0 01.769.2.686.686 0 00.806-.306.651.651 0 00.5.658.635.635 0 00.61-.247l.171-3.151a1.783 1.783 0 01.53-.3c.413-.147.645-.047 1.084-.2a1.66 1.66 0 00.482-.253c.8-.646.544-2.44.544-2.44l-2.6-.379a3.486 3.486 0 01-.755 1.231 7.2 7.2 0 00-1.079.324z"
          />
          <path
            d="M311.576 59.157c-.1-1.716-.374-2.748-1.132-3.558a2.986 2.986 0 00-2.27-1.081 3.4 3.4 0 00-2.655 2.979c-.157 3.728-.18 7.632-.029 11.694q.058 1.57.148 3.1c-.18.313-.515.912-.878 1.688-1.8 3.839-1.635 6.338-3.163 11.564a7.265 7.265 0 012.859 1.449 47.251 47.251 0 005.029-13.711c.733-3.861 1.295-6.63 1.7-8.559a21.578 21.578 0 00.391-5.565z"
            fill="url(#prefix__linear-gradient-16)"
          />
          <path
            d="M333.718 191.873a3.834 3.834 0 006.334-.1 4.47 4.47 0 01-.469-1.168 5.684 5.684 0 01-.107-1.561 11.506 11.506 0 01.256-2.04L334 188.516z"
            fill="#9c7761"
          />
          <path
            className="prefix__cls-36"
            d="M339.54 187.134l1.371-.959a2.9 2.9 0 001.176-1.755l.121-.553a17.7 17.7 0 00.405-4.114 2.4 2.4 0 00-1.314-2.081l-.215-.11a13.483 13.483 0 00-5.015-1.438l-3.42-.291a1.692 1.692 0 00-1.689-.668c-.778.24-.926 1.316-.736 2a2.23 2.23 0 001.08 1.279l2.891 5.979z"
          />
          <path
            className="prefix__cls-37"
            d="M331.946 178.316a19.268 19.268 0 00-1.106 4.642 7.76 7.76 0 01-.393.674c-.576.883-1.171 1.407-1.009 1.624.014.019.693.28.809.372.243.193.1 2.253.573 3.094.951 1.707 6.531 2.087 8.322-.46a3.492 3.492 0 00.59-2.073 2.378 2.378 0 01-.3-.113 2.509 2.509 0 01-1.187-1.136c-.453-.961.281-1.735-.191-2.117a.812.812 0 00-.754-.089c-.69.27-.79 1.7-.79 1.7h-.022c-.012 0-.269-.058-1.041-.242-.011-2.5-.663-3.433-1.3-3.8a5.411 5.411 0 01-1.259-.824 4.432 4.432 0 01-.942-1.252z"
          />
          <path
            d="M329.07 215.784c.2 2.652.5 6.55.938 11.278.561 6.079.854 9.118 1.054 10.139 1.068 5.443 3.8 14.295 4.627 19.139a6.489 6.489 0 01-.049 2.661 7.59 7.59 0 01-2.434 3.818c-1.275 1.057-2.5 1.284-2.431 1.7.067.4 1.248.673 2.307.49 1.192-.207 1.256-.828 3.018-1.794a13.534 13.534 0 002.535-1.394 2.048 2.048 0 00.224-.33 4.092 4.092 0 00.114-3.182l-3.011-43.223z"
            fill="url(#prefix__radial-gradient)"
          />
          <path
            d="M335.257 215.317c1.026 13.008 1.433 18.1 1.459 18.314v.021c.271 2.312.56 2.64.592 3.636.028.864-.19.6-.378 2.58-.074.781-.091 1.4-.1 1.754-.012.4-.01.879.02 1.57.2 4.669.978 5.03 1.568 10.766a65.067 65.067 0 01.42 8.672 59.428 59.428 0 01-.194 3.628 3.236 3.236 0 01.787 1.068c.419.935.11 1.578.6 2.031a1.9 1.9 0 001.342.346c.727.019 2.108-.151 2.316-.822.155-.5-.437-.954-.886-1.607-.863-1.252-.821-2.682-.658-4.721.42-5.239 1.431-11.831 1.715-14.466.194-1.806.347-3.664.347-3.664.041-.489.082-1.017.129-1.7.346-4.964.405-9.217.524-17.724.052-3.737.067-6.821.071-8.909a1.083 1.083 0 00-.089-.727c-.451-.8-2.123-.6-4.2-.418-1.227.108-3.066.255-5.385.372z"
            fill="url(#prefix__radial-gradient-2)"
          />
          <path
            className="prefix__cls-36"
            d="M338.967 258.206a8.031 8.031 0 01-2.8.528c-.154 0-.3-.015-.455-.023-.024.1-.039.193-.069.291 0 0-.062.231-.151.467a6.588 6.588 0 01-2.046 2.941 3.243 3.243 0 00-2.538 1.536 2.2 2.2 0 00-.193.813 4.151 4.151 0 002.371.253 4.29 4.29 0 00.63-.185 7.609 7.609 0 002.425-1.478 7.891 7.891 0 002.889-1.265q0-.453-.01-.908-.02-1.494-.053-2.97z"
          />
          <path
            className="prefix__cls-36"
            d="M342.141 262.552l.054-.633a17.023 17.023 0 01-3.352.274v.436a59.428 59.428 0 01-.194 3.628 3.236 3.236 0 01.787 1.068c.419.935.11 1.578.6 2.031a1.9 1.9 0 001.342.346c.727.019 2.108-.151 2.316-.822.155-.5-.437-.954-.886-1.607-.872-1.251-.831-2.682-.667-4.721z"
          />
          <path
            d="M360.073 172.63a40.724 40.724 0 01-1.923 4.724c-1.283 2.656-2.315 4.035-3.09 6.734a19.522 19.522 0 00-.559 2.6 42.566 42.566 0 00-5.741 4.041q-.238.2-.468.4a4.361 4.361 0 01-1.76.921 4.479 4.479 0 01-1.313.131c-1.961-.062-4.655-.357-5.167-.414a4.278 4.278 0 01-3.468 1.6 4.149 4.149 0 01-2.866-1.5c-.652.062-2.82.264-4.72.323a4.516 4.516 0 01-1.368-.141 4.357 4.357 0 01-1.719-.91q-.24-.207-.487-.413a42.559 42.559 0 00-5.741-4.041 19.546 19.546 0 00-.559-2.6c-.775-2.7-1.807-4.078-3.09-6.734a40.768 40.768 0 01-1.923-4.724l-3.126.817a65.794 65.794 0 002.847 12.148 65.737 65.737 0 001.7 4.487 26.549 26.549 0 004.452 5.052 38.819 38.819 0 014.927 4.369 20.523 20.523 0 012.226 3.123c.014.182.028.365.046.548a55.569 55.569 0 002.754 12.653 28.651 28.651 0 0016.961-.489c-.1-4.405-.093-9.01.056-13.8a59.959 59.959 0 013.48-3.619c4.619-4.411 7.285-5.523 8.969-9.247a21.013 21.013 0 00.948-3.08 179.594 179.594 0 002.847-12.148z"
            fill="url(#prefix__New_Gradient_Swatch_11)"
          />
          <path
            d="M333.91 203.121q-.024-5.737-.192-11.248l-4.32.229a14.847 14.847 0 01-2.256 10.629l-.071 14.929a24.162 24.162 0 006.606 1.67q.259-7.866.233-16.209z"
            fill="url(#prefix__New_Gradient_Swatch_2)"
          />
          <path
            d="M345.14 192.084l-5.088-.316-.057 27.766a8.089 8.089 0 005.7-2.373 6.914 6.914 0 001.206-1.821l.056-13.8a16.043 16.043 0 01-1.814-9.457z"
            fill="url(#prefix__New_Gradient_Swatch_2-2)"
          />
          <path
            className="prefix__cls-37"
            d="M311.945 173.192a1.731 1.731 0 001.685.105 2.571 2.571 0 001.342-2.216c.053-.913-.4-1.176-.528-2.452a5.9 5.9 0 01.072-1.632 1.556 1.556 0 00-.829.4 1.792 1.792 0 00-.35 1.882 2.688 2.688 0 00-1.239.847c-.707.886-.934 2.442-.153 3.066z"
          />
          <path className="prefix__cls-43" d="M313.526 172.494l-3.155-12.467" />
          <path
            className="prefix__cls-37"
            d="M311.1 174.071a153.312 153.312 0 00-.886-3.729 1.64 1.64 0 01-.047-.682 2.727 2.727 0 012.754-1.911c.109.017.4.063.475.25s-.138.368-.049.61c.071.19.236.164.281.334.066.251-.26.439-.177.637.054.129.214.1.293.238.1.175-.034.421-.085.517a1.581 1.581 0 01-1.053.689 1.307 1.307 0 01.771.618c.321.678-.273 1.527-.761 1.925a2.38 2.38 0 01-1.516.504zM362.227 172.866a1.731 1.731 0 01-1.685.105 2.571 2.571 0 01-1.342-2.216c-.053-.913.4-1.176.528-2.452a5.9 5.9 0 00-.072-1.632 1.556 1.556 0 01.829.4 1.792 1.792 0 01.35 1.882 2.688 2.688 0 011.239.847c.708.885.934 2.442.153 3.066z"
          />
          <path className="prefix__cls-43" d="M360.646 172.168l3.156-12.467" />
          <path
            className="prefix__cls-37"
            d="M363.074 173.745c.351-1.545.633-2.733.886-3.729a1.64 1.64 0 00.047-.682 2.727 2.727 0 00-2.754-1.911c-.109.017-.4.063-.475.25s.138.368.049.61c-.071.19-.236.164-.281.334-.066.251.26.439.177.637-.054.129-.214.1-.293.238-.1.175.034.421.085.517a1.581 1.581 0 001.053.689 1.307 1.307 0 00-.771.618c-.321.678.273 1.527.761 1.925a2.38 2.38 0 001.516.504z"
          />
          <path
            className="prefix__cls-45"
            d="M193.431 225.452l-35.068 13.455v5.37l35.068-14.103v-4.722zM193.431 233.407l-35.068 14.103v4.877l35.068-14.331v-4.649z"
          />
          <path
            className="prefix__cls-33"
            d="M193.431 223.845L158.363 237.3v1.607l35.068-13.455v-1.607z"
          />
          <path
            className="prefix__cls-33"
            d="M193.431 223.845v-1.606l-35.068 13.455v1.606l35.068-13.455zM193.431 239.676v-1.62l-35.068 14.331v1.62l35.068-14.331zM158.363 254.007v1.621l35.068-14.331v-1.621l-35.068 14.331zM193.431 231.791l-35.068 14.102v1.617l35.068-14.103v-1.616z"
          />
          <path
            className="prefix__cls-33"
            d="M193.431 231.791v-1.617l-35.068 14.103v1.616l35.068-14.102z"
          />
          <g id="prefix__Layer_2-2" data-name="Layer 2">
            <g id="prefix__Blue">
              <path
                d="M112.683 209.117c-.354-.3-.9-.06-1.114.6l-5.381 15.769c-.159.466-.014.9.324.962a.542.542 0 00.305-.036l7.882-3.159a1.1 1.1 0 00.6-.7c1.609-4.864.448-10.827-2.616-13.436z"
                fill="url(#prefix__linear-gradient-17)"
              />
              <path
                className="prefix__cls-21"
                d="M116.582 195.167c-3.043 7.254-2.7 13.8-.508 17.938l3.987 7.545a.458.458 0 00.615.211l7.882-3.159a1.2 1.2 0 00.66-1.078.745.745 0 00-.079-.333s-11.126-21.066-11.4-21.592c-.257-.468-.863-.238-1.157.468z"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default InboxImg;
